import { CardBody } from "@stenajs-webui/elements";
import type { FC, ReactNode } from "react";

import {
  BookingDetailsSectionHeader,
  type BookingDetailsSectionHeaderProps,
} from "./BookingDetailsSectionHeader";

import styles from "./BookingSection.module.css";

interface BookingDetailsSectionProps extends BookingDetailsSectionHeaderProps {
  children?: ReactNode;
  disablePadding?: boolean;
}

export const BookingSection: FC<BookingDetailsSectionProps> = ({
  title,
  disablePadding = false,
  children,
}) => (
  <>
    <BookingDetailsSectionHeader title={title} />

    {disablePadding ? (
      children
    ) : (
      <CardBody gap={3} className={styles.bookingSection}>
        {children}
      </CardBody>
    )}
  </>
);
